module.exports = __webpack_public_path__ + "static/img/anxunu07.9b5cb954.svg";